module.exports = __webpack_public_path__ + "img/belgium-skin-connective-and-musculoskeletal-diseases-male.4ce29ffa.png";